import React, { PureComponent } from "react";
import { Route, Redirect } from "react-router-dom";
import { omit } from "lodash";

class PublicRoute extends PureComponent {
	getPageForRole = (isLoggedIn, role) => {
		let page = "";
		if (isLoggedIn && role !== "") {
			page = "/home-screen";
		}
		return page;
	};

	render() {
		const { isLoggedIn, role } = this.props;
		const oldProps = omit(this.props, "isLoggedIn");
		const page = this.getPageForRole(isLoggedIn, role);

		return isLoggedIn ? <Redirect to={page} /> : <Route {...oldProps} />;

	}
}

export default PublicRoute;
